import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "vehicletype-config"

function* loadVehicleTypeConfigs(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadVehicleTypeConfigs.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadVehicleTypeConfigs.failure(getErrorMsg(error)));
  }
}

function* showVehicleTypeConfig(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showVehicleTypeConfig.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showVehicleTypeConfig.failure(getErrorMsg(error)));
  }
}

function* createVehicleTypeConfig(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createVehicleTypeConfig.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createVehicleTypeConfig.failure(getErrorMsg(error)));
  }
}

function* updateVehicleTypeConfig(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updateVehicleTypeConfig.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.updateVehicleTypeConfig.failure(getErrorMsg(error)));
  }
}

function* deleteVehicleTypeConfig(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deleteVehicleTypeConfig.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deleteVehicleTypeConfig.failure(getErrorMsg(error)));
  }
}

function* importVehicleTypeConfig(action) {
  try {
    const { file, token } = action.payload;
    const formData = new FormData();
    formData.append("file_name", file.originFileObj);
    const res = yield fetcher.upload(`${url}/import`, formData, token);
    yield put(actions.importVehicleTypeConfig.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.importVehicleTypeConfig.failure(getErrorMsg(error)));
  }
}

function* exportVehicleTypeConfig(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/export`, params, token);
    yield put(actions.exportVehicleTypeConfig.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    yield put(actions.exportVehicleTypeConfig.failure(getErrorMsg(error)));
  }
}


export default function* watchVehicleTypeConfig() {
  yield all([
    takeEvery(actions.LOAD_VEHICLETYPE_CONFIG.REQUEST, loadVehicleTypeConfigs),
    takeEvery(actions.SHOW_VEHICLETYPE_CONFIG.REQUEST, showVehicleTypeConfig),
    takeEvery(actions.CREATE_VEHICLETYPE_CONFIG.REQUEST, createVehicleTypeConfig),
    takeEvery(actions.UPDATE_VEHICLETYPE_CONFIG.REQUEST, updateVehicleTypeConfig),
    takeEvery(actions.DELETE_VEHICLETYPE_CONFIG.REQUEST, deleteVehicleTypeConfig),
    takeEvery(actions.IMPORT_VEHICLETYPE_CONFIG.REQUEST, importVehicleTypeConfig),
    takeEvery(actions.EXPORT_VEHICLETYPE_CONFIG.REQUEST, exportVehicleTypeConfig),
  ]);
}
